import { render, staticRenderFns } from "./Trails.vue?vue&type=template&id=2dd82ed0&scoped=true&"
import script from "./Trails.vue?vue&type=script&lang=js&"
export * from "./Trails.vue?vue&type=script&lang=js&"
import style0 from "./Trails.vue?vue&type=style&index=0&id=2dd82ed0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd82ed0",
  null
  
)

component.options.__file = "Trails.vue"
export default component.exports